@if(address()) {
<p>{{ address() }}</p>
}
@if(fullAddress) {
<p>{{ fullAddress }} </p>
}
